import { EnvironmentModel } from '@env/environment.model';

export const environment: EnvironmentModel = {
  env: 'qa',
  production: true,
  apiUrl: 'https://cpba-qa.nmfta.org/',
  oktaIssuer: 'https://nmftapartners.oktapreview.com/oauth2/default',
  clientId: '0oa11hizca0UQnkVx1d8', //qa,
  debug: true,
  enableIndexedDB: true,
};
